import HomeWorkIcon from "@mui/icons-material/HomeWork";
import ListPractices from "./List";
import { PRACTICES, AdministrationServicePath } from "utils/constants";
import EditPractices from "./Edit";
import CreatePractices from "./Create";
import permissions from "app/permissions";

//permissions
export const resources = {
  isMenu: true,
  recordRepresentation: "nameBg",
  icon: <HomeWorkIcon />,
  name: AdministrationServicePath + PRACTICES,
  title: "Практики",
  list: <ListPractices />,
  create: <CreatePractices />,
  createPermission: permissions.canCreatePractices,
  edit: <EditPractices />,
  editPermission: permissions.canUpdatePractices,
  permission: permissions.canPreviewPractices,
};
